// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Z4nR","col":"styles_col__1A7Ju"};